export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "919871834564";
export const WHATSAPP_MESSAGE = encodeURIComponent(
  "Hi MyySpace, I'd like to request a listening session. Could you help me?"
);
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;
